"use client";

const PageLoader = () => {
  return (
    <>
      <div className="loader loader4">
        <div>
          <div>
            <div>
              <div>
                <div>
                  <div>
                    <div>
                      <div>
                        <div>
                          <div></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        @keyframes rotate {
          0% {
            transform: rotate(0deg);
          }
          50% {
            transform: rotate(180deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        @keyframes rotate2 {
          0% {
            transform: rotate(0deg);
            border-top-color: rgba(0, 0, 0, 0.5);
          }
          50% {
            transform: rotate(180deg);
            border-top-color: rgba(0, 0, 255, 0.5);
          }
          100% {
            transform: rotate(360deg);
            border-top-color: rgba(0, 0, 0, 0.5);
          }
        }

        .loader {
          position: relative;
          margin: 75px auto;
          width: 150px;
          height: 150px;
          display: block;
          overflow: hidden;
        }

        .loader div {
          height: 100%;
        }

        /* loader 4 */
        .loader4,
        .loader4 div {
          border-radius: 50%;
          padding: 4px;
          border: 2px solid transparent;
          animation: rotate2 4s infinite linear;
        }

        .loader4:hover,
        .loader4 div:hover {
          animation-play-state: paused;
        }

        .loader,
        .loader * {
          will-change: transform;
        }
      `}</style>
    </>
  );
};

export default PageLoader;